import { useEffect, useState } from "react";
import axios from "axios";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { getLocations } from "@/lib/api";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/dealer-content/events`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });
const blank = { location_id: "", title: "", description: "", start: "", end: "" };

// Admin posts (or edits) an event for any store; it is approved right away and gets its flyer + blog post
export const AdminEventForm = ({ onDone, initial }) => {
  const [stores, setStores] = useState([]);
  const [f, setF] = useState(initial ? { location_id: initial.location_id, title: initial.title, description: initial.description || "", start: initial.start, end: initial.end || "" } : blank);
  const [busy, setBusy] = useState(false);
  const [q, setQ] = useState("");
  const match = (t) => stores.filter((s) => !t || [s.name, s.address, s.city, s.state, s.zip_code].filter(Boolean).join(" ").toLowerCase().includes(t.toLowerCase()));
  const options = (t) => { const m = match(t); const cur = stores.find((s) => s.id === f.location_id); return cur && !m.includes(cur) ? [cur, ...m] : m; };
  useEffect(() => { getLocations(true).then((d) => setStores(d || [])).catch(() => {}); }, []);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const go = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      if (initial) { await axios.put(`${API}/${initial.id}`, f, auth()); toast.success("Event updated. The flyer and blog post are being refreshed."); }
      else { await axios.post(API, f, auth()); toast.success("Event posted. Its flyer and blog post are being created now."); setF(blank); }
      onDone();
    }
    catch (er) { const d = er.response?.data?.detail; toast.error(Array.isArray(d) ? d.map((x) => x.msg).join("; ") : d || "Couldn't post event"); }
    finally { setBusy(false); }
  };
  return (
    <Card className="border-teal/30 bg-teal/5"><CardContent className="p-4">
      <form onSubmit={go} className="grid sm:grid-cols-2 gap-3" data-testid="admin-event-form">
        <div><Label>Store *</Label>
          <Input value={q} onChange={(e) => { setQ(e.target.value); const m = match(e.target.value); if (m.length === 1) setF((p) => ({ ...p, location_id: m[0].id })); }}
            placeholder="Search store name, city or address…" className="mt-1 h-9 text-sm" data-testid="admin-event-store-search" />
          <select required value={f.location_id} onChange={set("location_id")} className="mt-1 w-full h-10 border border-input rounded-md px-2 text-sm bg-white" data-testid="admin-event-store">
            <option value="">{q ? `${match(q).length} matching store(s), pick one` : "Pick a store"}</option>
            {options(q).map((s) => <option key={s.id} value={s.id}>{s.name}{s.address ? ` · ${s.address}` : ""}{s.city ? `, ${s.city}` : ""}</option>)}
          </select></div>
        <div><Label>Event name *</Label><Input required minLength={3} value={f.title} onChange={set("title")} placeholder="e.g. Grand Opening Celebration" data-testid="admin-event-title" /></div>
        <div><Label>Starts *</Label><Input required type="datetime-local" value={f.start} onChange={set("start")} data-testid="admin-event-start" /></div>
        <div><Label>Ends</Label><Input type="datetime-local" value={f.end} onChange={set("end")} data-testid="admin-event-end" /></div>
        <div className="sm:col-span-2"><Label>Details</Label><Textarea rows={3} value={f.description} onChange={set("description")} placeholder="Giveaways, deals, music…" data-testid="admin-event-description" /></div>
        <Button disabled={busy} className="sm:col-span-2 bg-teal hover:bg-teal-dark text-white" data-testid="admin-event-submit">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : initial ? "Save changes" : "Post event"}</Button>
      </form>
    </CardContent></Card>
  );
};
